import React, { useState, useEffect, useRef, useCallback } from "react";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { Toast } from "primereact/toast";
import { getListaMatricula } from "../../service/Matricula";
import { useDispatch, useSelector } from "react-redux";
import { loading, setUsuarioLogin } from "../../actions";
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import "./styleDropdown.css";

export const PageLibroRegistro = ({ value = null, hideRegistro = null }) => {
    const [globalFilter, setGlobalFilter] = useState("");
    const [dataTable, setDataTable] = useState(null);
    const [dataTableFilter, setDataTableFilter] = useState(null);
    const dispatch = useDispatch();
    const toast = useRef(null);
    const [libro, setLibro] = useState(value);
    const [selectedCity1, setSelectedCity1] = useState(null);
    const [activeIndex2, setActiveIndex2] = useState(0);

    // const navigate = useNavigate();
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    const cities = [
        { name: 'EQUIPO DE AULA', code: 'NY' },
        { name: 'PLANIFICACIÓN DEL PROCESO EDUCATIVO', code: 'RM' },
        { name: 'REGISTRO DE LA IMPLEMENTACIÓN Y EVALUACIÓN DEL PROCESO EDUCATIVO', code: 'LDN' },
        { name: 'REGISTRO DE ACTIVIDADES CON LA FAMILIA Y LA COMUNIDAD', code: 'IST' },
        { name: 'ACTA DE REUNIONES', code: 'PRS' }
    ];
    const scrollableTabs = Array.from({ length: 10 }, (_, i) => ({ title: `Tab ${i + 1}`, content: `Tab ${i + 1} Content` }));

    const onCityChange = (e) => {
        setSelectedCity1(e.value);
    }

    useEffect(() => {
        loadData();
    }, [anio]);

    useEffect(() => {
        setLibro(value);
    }, [value]);

    const loadData = async () => {
        if (colegio.id !== undefined && anio.anio !== undefined) {
            dispatch(loading(true));
            var data = await getListaMatricula(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                setDataTable(data.matricula_pie);
                setDataTableFilter(data.matricula_pie);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
            dispatch(loading(false));
        } else {
            setDataTable([]);
            setDataTableFilter([]);
        }
    };

    //libro

    const dataTableHeader = (
        <div className="p-shadow-1 p-p-3">
            <div className="p-formgrid p-grid p-col-12 p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8">
                    <Button icon="pi pi-arrow-left" className="p-button-rounded" onClick={hideRegistro} />
                    <div style={{ display: "inline-block", padding: "7px" }}>
                    Registro de planificación y evaluación de actividades del curso {libro !== null ? libro.nivel + " " + libro.grado : ""}
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-lg-4 section" style={{ textAlign: "right" }}>
                    
                    <Dropdown value={selectedCity1} options={cities} onChange={onCityChange} optionLabel="name" placeholder="Seleccionar" />
                    
                    {/* <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadData}></Button>*/}
                </div>
            </div>
        </div>
    );

    return (
        <div className="p-formgrid p-grid p-col-12 card p-fluid p-pt-0">
            <Toast ref={toast} />

            <div className="p-col-12 p-md-12 p-lg-12">{dataTableHeader}</div>
            <div className="p-col-12 p-md-12 p-lg-12">
            <div className="card">
                <h5>Scrollable</h5>
                <div className="py-2">
                    <Button onClick={() => setActiveIndex2(0)} className="p-button-text mr-1" label="Activate 0" />
                    <Button onClick={() => setActiveIndex2(5)} className="p-button-text mr-1" label="Activate 5" />
                    <Button onClick={() => setActiveIndex2(7)} className="p-button-text" label="Activate 7" />
                </div>

                <TabView activeIndex={activeIndex2} onTabChange={(e) => setActiveIndex2(e.index)} scrollable>
                    {scrollableTabs.map((tab) => {
                        return (
                            <TabPanel key={tab.title} header={tab.title}>
                                <p>{tab.content}</p>
                            </TabPanel>
                        )
                    })}
                </TabView>
            </div>
            </div>
        </div>
    );
};
